export const colors = [
  {
    color: '#8d9a05',
    backgroundColor: '#f4fca2',
  },
  {
    color: '#8c0606',
    backgroundColor: '#fa9797',
  },
  {
    color: '#034010',
    backgroundColor: '#adfbbd',
  },
  {
    color: '#001929',
    backgroundColor: '#90d3fe',
  },
  {
    color: '#84047e',
    backgroundColor: '#ffeffe',
  },
];
